import { process } from "am-tax-fe-core";

import { components } from "../generated/generated-api";
import { client } from "../entities/entityApi";

//#region Dto definition
export type Report = components["schemas"]["ReportDto"];
export type ReportByClientId = components["schemas"]["GetReportByClientIdDto"];
export type CreateReport = components["schemas"]["CreateOrUpdateReportDto"];
export type UpdateReport = components["schemas"]["CreateOrUpdateReportDto"] & { id: string };

export const getReportAsync = async (id: string): Promise<Report> =>
    process(
        client().GET("/api/reports/{reportId}", {
            params: {
                path: {
                    reportId: id,
                },
            },
        }),
    );

export const getReportsAsync = async (): Promise<Report[]> => process(client().GET("/api/reports"));

export const getReportsByUserEmailAsync = async (): Promise<Report[]> => process(client().GET("/api/reports/user"));

export const getReportsByClientIdAsync = async (clientId: string): Promise<ReportByClientId[]> =>
    process(
        client().GET("/api/reports/client/{clientId}", {
            params: {
                path: {
                    clientId: clientId,
                },
            },
        }),
    );

export const createReportAsync = async (args: CreateReport): Promise<Report> => process(client().POST("/api/reports", { body: args }));

export const createRolloverReportAsync = async (reportId: string): Promise<Report> =>
    process(
        client().POST("/api/reports/{reportId}/rollover", {
            params: {
                path: {
                    reportId: reportId,
                },
            },
        }),
    );

export const updateReportAsync = async (args: UpdateReport): Promise<Report> =>
    process(
        client().PUT("/api/reports/{reportId}", {
            params: {
                path: {
                    reportId: args.id,
                },
            },
            body: args,
        }),
    );

export const deleteReportAsync = async (id: string): Promise<Report> =>
    process(
        client().DELETE("/api/reports/{reportId}", {
            params: {
                path: {
                    reportId: id,
                },
            },
        }),
    );

export const generateReportAsync = async (id: string): Promise<unknown> =>
    process(
        client().POST("/api/reports/{reportId}/generate", {
            params: {
                path: {
                    reportId: id,
                },
            },
        }),
    );

export const downloadReportAsync = async (id: string): Promise<Response> => {
    const result = await client().GET("/api/reports/{reportId}/download", {
        params: {
            path: {
                reportId: id,
            },
        },
        parseAs: "stream",
    });

    if (!result.response || !result.response.ok) {
        throw new Error(`Failed to download report: ${result.response?.statusText || "Unknown error"}`);
    }

    return result.response;
};
